var map = {
	"./partners-1.png": "d657",
	"./partners-2.png": "5529",
	"./partners-3.png": "7535",
	"./partners-4.png": "74cc",
	"./partners-5.png": "a57b",
	"./partners-6.png": "67dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "98c9";